import { useRef, useEffect } from "react";
import { usePurchase } from "../../../../../global/paywall/usePurchase";
import { SubscriptionPlan, ProductsUniqueIds } from "../../../../../global/paywall/paywallInterfaces";


interface PaywallCheckoutPaymentDetailsProps {
    nextStep: () => void
    selectedPlan: SubscriptionPlan;
}

const PaywallCheckoutPaymentDetails = (props: PaywallCheckoutPaymentDetailsProps) => {
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const {selectedPlan} = props;
    const { purchaseStatus, paymentUrl, error, resetPurchase } = usePurchase(selectedPlan.productUniqueId);
    const planText = selectedPlan.productUniqueId === ProductsUniqueIds.MONTHLY_PASS ? 'חבילה חודשית ב-₪29.90 לחודש' : 'חבילה שנתית ב-₪299.90 לשנה';
    
        useEffect(() => {
        if (purchaseStatus === "completed") {
            props.nextStep()
        }
    }, [purchaseStatus])

    return (
        <div className="PaywallCheckoutPaymentDetails">
            <div className="title-step-container"><span className="title"> פרטי תשלום </span> / <span className="plan-title">{planText}</span></div>
            <div className="creditcard-details-container">
                <iframe ref={iframeRef as any} src={paymentUrl} />
            </div>
        </div>
    );
};

export default PaywallCheckoutPaymentDetails;